import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';
import { useAppDispatch } from '../../../hooks';
import CircleOrAltIcon from '../../Icons/CircleOrAltIcon';
import { closeDrawer } from '../rightDrawerSlice';

// const GetTakeGroup = graphql(`
//     query GetTakeGroup_Takes($where: TakeGroupWhere) {
//         takeGroups(where: $where) {
//             id
//             take
//             note
//             takes {
//                 id
//                 subTake
//                 note
//                 recordingsConnection {
//                     edges {
//                         properties {
//                             circled
//                             alt
//                         }
//                         node {
//                             line {
//                                 lineNo
//                                 ordinal
//                             }
//                             audio {
//                                 tag
//                                 ordinal
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//     }
// `);

export type TakesProps = {
    groupId: string
}

export default function Takes({ groupId }: TakesProps) {
    const dispatch = useAppDispatch();

    // const { data, loading } = useQuery(GetTakeGroup, {
    //     variables: {
    //         where: {
    //             id: groupId,
    //         },
    //     },
    // });

    // es-lint-disable-next-line @typescript-eslint/no-explicit-any

    const allCircled = false;
    // data?.takeGroups?.[0]?.takes?.every(t =>
    //     t.recordingsConnection.edges.every(r => r.properties.circled)) ?? false;
    const allAlt = false;
    // data?.takeGroups?.[0]?.takes?.every(t =>
    //     t.recordingsConnection.edges.every(r => r.properties.alt)) ?? false;

    // I hate this
    // const lineInfo = new Set(data?.takeGroups?.[0]?.takes?.
    //     map(t => t.recordingsConnection.edges
    //         .map(r => ({
    //             linoNo: r.node.line.length > 0 ? r.node.line[0].lineNo : r.node.audio[0].tag,
    //             ordinal: r.node.line.length > 0 ? r.node.line[0].ordinal : r.node.audio[0].ordinal,
    //         }))
    //     )
    //     .flat()
    //     .toSorted((a, b) => a.ordinal - b.ordinal)
    //     .map(l => l.linoNo)
    // )
    const lineInfo = new Set();
    //
    // const take = data?.takeGroups?.[0]?.take;
    // const sortedTakes = take
    //     ? data?.takeGroups?.[0]?.takes?.
    //         toSorted((a, b) =>
    //             sortByTakeAndSubTake({ take, subTake: a.subTake }, { take, subTake: b.subTake })
    //         ) ?? []
    //     : [];

    const handleClick = () => {
        dispatch(closeDrawer());
    }

    // if (loading) return <LinearProgress />

    if (!groupId) return null;

    return (
        <>
            <Typography sx={{ m: 1 }}>
                Lines: {Array.from(lineInfo).join(', ')}
            </Typography>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}>
                {(allCircled || allAlt) && (
                    <CircleOrAltIcon circle={allCircled} alt={allAlt} />
                )}
                {/*<Typography sx={{ width: 50, m: 1 }}>{data?.takeGroups?.[0]?.take}</Typography>*/}
                {/*<Typography sx={{ m: 1 }}>{data?.takeGroups?.[0]?.note}</Typography>*/}
            </Box>
            <Divider />
            {/*{sortedTakes.map(t => {*/}
            {/*    const circled = t.recordingsConnection.edges.every(r => r.properties.circled);*/}
            {/*    const alt = t.recordingsConnection.edges.every(r => r.properties.alt);*/}

            {/*    return (*/}
            {/*        <>*/}
            {/*            <Box key={t.id} sx={{*/}
            {/*                display: 'flex',*/}
            {/*                flexDirection: 'row',*/}
            {/*                alignItems: 'center',*/}
            {/*                pl: 3,*/}
            {/*            }}>*/}
            {/*                {(circled || alt) && (*/}
            {/*                    <CircleOrAltIcon circle={circled} alt={alt} />*/}
            {/*                )}*/}
            {/*                <Typography sx={{ width: 50, m: 1 }}>{t.subTake}</Typography>*/}
            {/*                <Typography sx={{ m: 1 }}>{t.note}</Typography>*/}
            {/*            </Box>*/}
            {/*            <Divider />*/}
            {/*        </>*/}
            {/*    );*/}
            {/*})}*/}
            <Button onClick={handleClick}>Close</Button>
        </>
    )
}